import {dismissDataViewerRowEngagementPanel} from "~/components/ottopilotDataViewer/rowEngagement/dismissDataViewerRowEngagementPanel";
import type {OttopilotDataViewerController} from "~/components/ottopilotDataViewer/ottopilotDataViewerController";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export type DismissDataViewerAsidePanelsOptions<TRow extends {id: Uuid}> = {
    controllerRef?: {current: OttopilotDataViewerController<TRow> | null};
    closeCreateDrawer?: () => void;
    closeNotesPanel?: () => void;
    closeDisposition?: () => void;
    closeScheduleCall?: () => void;
    dismissArchive?: () => void;
};

/** Closes view/edit and other row-action side panels before opening another action. */
export function dismissDataViewerAsidePanels<TRow extends {id: Uuid}>(
    options: DismissDataViewerAsidePanelsOptions<TRow>,
): void {
    dismissDataViewerRowEngagementPanel(options.controllerRef);
    options.closeCreateDrawer?.();
    options.closeNotesPanel?.();
    options.closeDisposition?.();
    options.closeScheduleCall?.();
    options.dismissArchive?.();
}
